/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progression_Deload_WeekInputs */

const en_us2_progression_deload_week = /** @type {(inputs: Progression_Deload_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lighter week: volume comes down so your body can recover`)
};

const pt_br2_progression_deload_week = /** @type {(inputs: Progression_Deload_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana mais leve: o volume diminui para o corpo se recuperar`)
};

const es_419_progression_deload_week = /** @type {(inputs: Progression_Deload_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana más ligera: el volumen baja para que tu cuerpo se recupere`)
};

const pt_pt2_progression_deload_week = /** @type {(inputs: Progression_Deload_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana mais leve: o volume diminui para o corpo recuperar`)
};

const fr_fr2_progression_deload_week = /** @type {(inputs: Progression_Deload_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine plus légère : le volume baisse pour que ton corps récupère`)
};

const de_de2_progression_deload_week = /** @type {(inputs: Progression_Deload_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leichtere Woche: Das Volumen sinkt, damit sich dein Körper erholen kann`)
};

const it_it2_progression_deload_week = /** @type {(inputs: Progression_Deload_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settimana più leggera: il volume scende per far recuperare il corpo`)
};

/**
* | output |
* | --- |
* | "Lighter week: volume comes down so your body can recover" |
*
* @param {Progression_Deload_WeekInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_deload_week = /** @type {((inputs?: Progression_Deload_WeekInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_Deload_WeekInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_deload_week(inputs)
	if (locale === "es-419") return es_419_progression_deload_week(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_deload_week(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_deload_week(inputs)
	if (locale === "de-DE") return de_de2_progression_deload_week(inputs)
	if (locale === "it-IT") return it_it2_progression_deload_week(inputs)
	return en_us2_progression_deload_week(inputs)
});
export { progression_deload_week as "progression.deload_week" }